(() => {
    class Summary extends App.Component {
        constructor(container) {
            super(container);
            this.set(this.read('product'), this.read('design'));
            this.render();
            this.update();
        }

        set(product, design) {
            this.product    = product;
            this.design     = design;
            return this;
        }

        set content(content) {
            this.container.innerHTML = content;
        }

        get cta() {
            return this.container.querySelector('.summary-cta')?.getComponent();
        }

        get product() {
            return this._product;
        }

        set product(id) {
            if (id) {
                this._product = App.Endpoint.Products.getById(id);
                this.update();
            }
        }

        get design() {
            return this._design;
        }

        set design(id) {
            if (id) {
                App.Endpoint.Designs.getById(id).then(design => {
                    this._design = design;
                    this.update();
                });
            }
        }

        async getValues() {
            return await App.Interface.Product.getFormatedValues(this.product?.id, this.design?.id);
        }

        hidePrice(hide = true) {
            this.container.classList.toggle('no-price', hide);
        }

        async render() {
            const values = await this.getValues();
            if (this.product) {
                this.content = App.Template.parse('product-summary-success', values);
            } else {
                this.content = App.Template.parse('product-summary-mix', values);
            }
        }

        async update() {
            const values = await this.getValues();
            super.update(() => {
                this.container.querySelectorAll('.js-product-summary-weight').forEach(e => e.innerHTML      = values.weight);
                this.container.querySelectorAll('.js-product-summary-total').forEach(e => e.innerHTML       = values.total);
                this.container.querySelectorAll('.js-product-summary-gram-price').forEach(e => e.innerHTML  = values.gramPrice);
            });
        }
    }
    App.Components.register(App.Components.selector('product-summary'), Summary);
})();

